import styled from 'styled-components';

export const FormContainer = styled.div`
  margin-top: 28px;
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PhoneInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CountrySelector = styled.button`
  position: absolute;
  left: 2px;
  top: 2px;
  bottom: 2px;
  background: #F4F5F7;
  border: none;
  border-right: 1.5px solid #D9DDE3;
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 2;
  border-radius: 8px 0 0 8px;
  transition: background 0.15s;

  &:hover {
    background: #ecedf0;
  }
`;

export const CountryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: white;
  border: 1.5px solid #D9DDE3;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  width: 300px;
  max-height: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const CountrySearchInput = styled.input`
  width: 100%;
  padding: 12px;
  border: none;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  font-size: 14px;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const CountryList = styled.div`
  overflow-y: auto;
  max-height: 250px;
`;

export const CountryItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #f9fafb;
  }
`;

export const InfoLink = styled.a<{ color: string }>`
  color: ${({ color }) => color ?? '#00D95F'};
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Brand = styled.img`
  width: 70%;
`;
